class LStorage {
    constructor() {
    }

    setItem(a,b) {
        return;
        //window.localStorage.setItem(a,b);
    }

    getItem(a) {
        return null;
        //return window.localStorage.getItem(a);
    }
}

export const lstorage = new LStorage();
